<template>
	<div class="jwt-play">
		<div
			class="jwt-play_play-btn"
			:class="{
				'jwt-play_play-btn--disable': disable,
			}"
		>
			<slot>
				<FontAwesomeIcon :icon="faPlay" size="2x" />
			</slot>

			<ProviderIcon class="jwt-play_icon" providerShortName="jwt" size="small" />
		</div>
		<span class="jwt-play_text"> {{ $t('WEBAPP_FREE_STREAM') }}</span>
	</div>
</template>
<script lang="ts" setup>
import ProviderIcon from '@/components/picture/ProviderIcon.vue';
import { faPlay } from '@fortawesome/free-solid-svg-icons';

defineProps<{ disable?: boolean }>();
</script>

<style lang="scss" scoped>
@import '~@/styles/mixins.scss';

.jwt-play {
	display: flex;
	flex-direction: column;
	align-items: center;
	gap: 8px;
	cursor: pointer;
	position: relative;
	@include sm() {
		flex-direction: row;
		margin-inline-start: 16px;
	}
	&_play-btn {
		position: relative;
		border-radius: 500px;
		height: 64px;
		width: 64px;
		display: flex;
		justify-content: center;
		align-items: center;
		background-color: #fbc500;
		color: #000000;
		box-shadow: 4px 10px 40px 4px rgba(0, 0, 0, 0.75);

		//z-index: 3;
		&--disable {
			pointer-events: none;
		}
	}
	&_text {
		@include md() {
			position: absolute;
		}

		text-wrap: nowrap;
		bottom: -30px;
		font-size: 16px;
		color: #fbc500;
		font-weight: 600;
		text-shadow: 0 4px 15px rgba(0, 0, 0, 0.75);
		z-index: 2;
	}

	&_icon {
		position: absolute;
		bottom: -5px;
		inset-inline-end: -5px;
		margin-inline-end: 5px;
	}
}
</style>
